export default __webpack_public_path__ + "static/media/ios Bitmap@2x.5ce9f05e.png";